(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('zaros-gallery-count'))customElements.define('zaros-gallery-count',class extends HTMLElement{
connectedCallback(){this.gallery=this.closest('product-gallery');if(!this.gallery?.classList.contains('zaros-mobile-gallery'))return;this.update=()=>{const buttons=[...this.gallery.querySelectorAll('.product-gallery__thumbnail')].filter(b=>!b.hidden);const active=buttons.findIndex(b=>b.getAttribute('aria-current')==='true');this.textContent=buttons.length?(Math.max(0,active)+1)+' / '+buttons.length:''};this.observer=new MutationObserver(this.update);this.observer.observe(this.gallery,{subtree:true,attributes:true,attributeFilter:['hidden','aria-current']});this.update()}
disconnectedCallback(){this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
